interface LogoProps {
  /** Hide the wordmark — shows only the icon mark. */
  withWordmark?: boolean;
  /**
   * Render for a dark background (e.g. LoginPage hero panel).
   * Applies CSS brightness-0+invert so the asset appears white.
   * When a dedicated /logo-white.svg ships, swap the src here.
   */
  onDark?: boolean;
}

export default function Logo({ withWordmark = true, onDark = false }: LogoProps) {
  const filterClass = onDark ? "brightness-0 invert" : "";

  if (withWordmark) {
    return (
      <img
        src="/logo.svg"
        alt="RoadBridge"
        height={40}
        className={`h-10 w-auto${filterClass ? ` ${filterClass}` : ""}`}
      />
    );
  }
  return (
    <img
      src="/favicon.png"
      alt="RoadBridge"
      width={32}
      height={32}
      className={`h-8 w-8${filterClass ? ` ${filterClass}` : ""}`}
    />
  );
}
